export enum SubsectionHeadingLabel {
  BinType = "Bin Type",
  QuantileType = "Quantile Type"
}
